import { pageTurnoverRunId } from '@messenger/utils'

/**
 * Whether a page set is turned over to Lotus text boxes: any of its pages
 * carries a turnover run id, in content stored as an object or as a JSON
 * string. Any page, not every page, so a set stays turned over when one page
 * arrives without the id.
 */
export const editorPageSetIsTurnedOver = (pages: readonly unknown[]): boolean =>
  pages.some((page) => pageTurnoverRunId(page) !== undefined)
